import React from 'react'
// import directly from module due to an unknown breaking issue with lerna/yarn workspaces
import { buildTagDataAttr } from '@cinch/oxd-utils/analytics/src/build-tag-data-attr'
import { Primary, PrimaryProps } from '@cinch-labs/design-system'

export interface PrimaryWrapperProps extends PrimaryProps {
  tag?: Cinch.AnalyticsTag
}

const PrimaryWrapper: React.FC<PrimaryWrapperProps> = ({ children, tag, ...rest }) => {
  const analyticsDataAttributes = buildTagDataAttr(tag)

  return (
    <Primary {...analyticsDataAttributes} {...rest}>
      {children}
    </Primary>
  )
}

export default PrimaryWrapper
